import api from './';

export const listarChavesPIX = (start, size, filters, filtersMode, globalFilter, sorting, contaId) =>
    api.get('/conta/listarChavesPIX', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            contaId,
        },
    });

export const createChavePIX = async (novaChave) => {
    try {
        const { data } = await api.post('/conta/createChavePIX', novaChave);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const duplicidadeChavePIX = async (contaId, descricao) => {
    try {
        const { data } = await api.get('/conta/duplicidadeChavePIX/', {
            params: { contaId, descricao },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const deletarChavePIX = (uuid) => api.post('/conta/deletarChavePIX', { uuid });

// Convênios: propagar erros para o formulário, sem converter falha em sucesso.
export const listarConvenios = (contaUuid) => api.get(`/conta/${encodeURIComponent(contaUuid)}/convenios`);
export const cadastrarConvenio = (contaUuid, dados) =>
    api.post(`/conta/${encodeURIComponent(contaUuid)}/convenios/cadastrar`, dados);
export const editarConvenio = (contaUuid, dados) => api.post(`/conta/${encodeURIComponent(contaUuid)}/convenios/editar`, dados);
export const situacaoConvenio = (contaUuid, dados) =>
    api.post(`/conta/${encodeURIComponent(contaUuid)}/convenios/situacao`, dados);

// Retornos: autorização e escopo são conferidos pelo servidor em cada requisição.
const retornoURL = (contaUuid, convenioUuid) =>
    `/conta/${encodeURIComponent(contaUuid)}/convenios/${encodeURIComponent(convenioUuid)}/retornos`;
export const listarRetornos = (contaUuid, convenioUuid, params) => api.get(retornoURL(contaUuid, convenioUuid), { params });
export const detalharRetorno = (contaUuid, convenioUuid, arquivoUuid, params) =>
    api.get(`${retornoURL(contaUuid, convenioUuid)}/${encodeURIComponent(arquivoUuid)}`, { params });
export const importarRetorno = (contaUuid, convenioUuid, arquivo) => {
    const dados = new FormData();
    dados.append('arquivo', arquivo);
    return api.post(retornoURL(contaUuid, convenioUuid), dados);
};

const sequenciaURL = (contaUuid, convenioUuid) =>
    `/conta/${encodeURIComponent(contaUuid)}/convenios/${encodeURIComponent(convenioUuid)}/sequencia`;
export const consultarSequenciaConvenio = (contaUuid, convenioUuid, params) =>
    api.get(sequenciaURL(contaUuid, convenioUuid), { params });
export const configurarSequenciaConvenio = (contaUuid, convenioUuid, dados) =>
    api.post(`${sequenciaURL(contaUuid, convenioUuid)}/configurar`, dados);
